module.exports = __webpack_public_path__ + "img/strange-matter-generator.abac5568.png";